export const sleep = (timeInMilliseconds: number): Promise<void> =>
  new Promise(resolve => {
    setTimeout(() => resolve(), timeInMilliseconds);
  });
